import type { AnnotationLabelT, GenericAnnotationReviewDataT, LabellingValidationsT } from '../../common/types/types';
import type { AttributesT } from '../../modernization-common/side-panel/annotations/types';
import type { RemainingItemsType } from '../../modernization-common/side-panel-m4/types';
import type { EntityTaggingAnnotationT } from './annotation.type';
import type { MEDIA_TYPET } from './studio-interface.type';
export type LabelStateT = {
  mediaUrl: string | undefined | null;
  mediaType: MEDIA_TYPET;
  selectedAnnotationLabel: AnnotationLabelT | undefined | null;
  annotationStore: AnnotationStoreT;
  annotationReviewStore: AnnotationReviewStoreT;
  selectedAnnotationIds: Array<string>;
  multiSelectEnabled: boolean;
  focusedAnnotationId: string | undefined | null;
  validations: LabellingValidationsT;
  showAnnotationDetails: boolean;
  minLength?: number | null;
  maxLength?: number | null;
  shouldPlayInLoop?: boolean | null;
  skipFrameTime?: number;
};
export type InitialLabelStateT = Partial<LabelStateT>;
export type AnnotationStoreT = {
  [key: string]: EntityTaggingAnnotationT;
};
export type AnnotationReviewStoreT = {
  [key: string]: GenericAnnotationReviewDataT;
};
export type EntityTaggingSidePanelAnnotationT = EntityTaggingAnnotationT & {
  id: string;
  tags: AttributesT[];
  canCopyObjectInstance: boolean;
};
export type RemainingItemsEntityTaggingAnnotationT = EntityTaggingSidePanelAnnotationT & {
  type: RemainingItemsType;
  message: string;
};
export * from '../components/multi-video/types';